import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import OverpackList from "../../components/overpack-list";
import buildQuery from "../../utils/query-builder";
import { overpackService } from "../../utils/services/overpackService";
import OverpackViewModal from "../../components/overpack-view-modal";
import { useTheme } from "@mui/styles";
import { useLocation } from "react-router-dom";
import { overpackFilterInitialState } from "../../utils/filter-config";

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x
        ),
      };
    case "SET_OPTIONS":
      return {
        ...state,
        columns: state.columns.map((col) =>
          col.key === action.payload.key
            ? { ...col, options: action.payload.options }
            : col
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    case "EXISTING_DATA":
      return {
        ...state,
        columns: state.columns.map((x) => ({
          ...x,
          filter:
            action.data.filters.find((y) => y.key === x.key)?.values ||
            x.filter,
        })),
        limit: action.data.limit || state.limit,
      };

    default:
      return state;
  }
}
const Overpack = () => {
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [filterData, dispatch] = useReducer(
    filterReducer,
    overpackFilterInitialState
  );
  const [overpackList, setoverpackList] = useState([]);
  const [page, setPage] = React.useState(0);
  const [dataCount, setDataCount] = useState(15);
  const [loading, setLoading] = useState(false);
  const [clientFilter, setClientFilter] = useState(null);
  const [fetchData, setFetchData] = useState(0);
  const [selectedOverpack, setSelectedOverpack] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const location = useLocation();

  const fetchOverpacks = async (signal, id) => {
    setLoading(true);
    try {
      const response = await overpackService.fetch(
        clientFilter?._id,
        buildQuery(filterData, page),
        {
          signal,
        },
        id
      );

      setoverpackList(response.data);
      setDataCount(response?.total || 0);
    } catch (error) {
      console.error("Fetch failed:", error);
      setoverpackList([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    if (id) {
      fetchOverpacks(null, id);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    fetchOverpacks(signal);
    return () => {
      controller.abort();
    };
  }, [page, filterData, clientFilter, fetchData]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  useEffect(() => {
    let data = localStorage.getItem("overpack-filter-data");
    if (location.search.includes("child") && data) {
      localStorage.removeItem("overpack-filter-data");
      dispatch({
        type: "EXISTING_DATA",
        data: JSON.parse(data),
      });
    }
  }, []);

  return (
    <>
      <DashboardContainer
        onChangeFilter={handleFilterChange}
        filterData={filterData}
        fields={filterData.columns}
        header={"Overpack List"}
        hideUploadButton
        onSelectClient={(e) => {
          setClientFilter(e);
        }}
        selectedClient={clientFilter?.name}
        hideAddButton
        manifest
        onClickRefresh={() => setFetchData((prev) => prev + 1)}
      >
        <OverpackViewModal
          data={selectedOverpack}
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            setEdit(false);
          }}
          primary_color={primary_color}
          edit={edit}
          onEditData={fetchOverpacks}
        />
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <OverpackList
            dataCount={dataCount}
            page={page}
            rowsPerPage={filterData.limit}
            setRowsPerPage={(e) =>
              dispatch({
                type: "UPDATE_LIMIT",
                payload: e,
              })
            }
            onEditData={(e) => {
              setSelectedOverpack(e);
              setOpenModal(true);
              setEdit(true);
            }}
            setPage={setPage}
            data={overpackList}
            selectedOverpack={selectedOverpack}
            setSelectedOverpack={setSelectedOverpack}
            onChangeFilter={handleFilterChange}
            filterData={filterData}
          />
        )}
      </DashboardContainer>
    </>
  );
};

export default Overpack;
